import { render, staticRenderFns } from "./DeleteWorksCouncilDialog.vue?vue&type=template&id=4f4a1e8e&"
import script from "./DeleteWorksCouncilDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteWorksCouncilDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports